import {Modal, Col, Row, Form} from 'react-bootstrap';
import React, { useContext, useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { UserContext } from '../../../UserContext';
import { validateFormFields } from '../../../utils';
import {FormInput} from '../../../components/formElements/FormInput';
import CommonService from '../../../services/CommonService';
import swal from 'sweetalert';
import CurrencyInput from '../../formElements/CurrencyInput';
import BaseService from '../../../services/BaseService';

const EditIssueAuthorization = (props) => {
    const user = useContext(UserContext);
    const {onModalClose, issueAuthInfo, cdiacNumber, tableType} = props;
    const [formErrors, setFormErrors] = useState({});
    const [issueAuth, setIssueAuth] = useState({...issueAuthInfo});
    
    
    const handleIssueAuthChange = e => {
        const { name } = e.target;
        let value = e.target.value;

        setIssueAuth(prevState => ({
            ...prevState, [name]: value
        }))
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        const form = e.target.closest('form#edit-issue-authorization');
        let formErrors = validateFormFields(form.elements);
        if(Object.keys(formErrors).length > 0) {
            setFormErrors(formErrors);
        } else {  
            setFormErrors({});
            var obj = {
            "msgId": null,
            "sysId": null,
            "opr": "updateIssueAuthorization",
            "hdrStruct": null,
            "queryParam": null,
            "reqData": {
                "id" : issueAuth.issuerAuthorizationId,
                "tableType": tableType,
                "issueAuthorization": {
                    "authorizationId": issueAuth.authorizationId,
                    "finalSaleId": issueAuth.finalSaleId,
                    "proposeDebtId": issueAuth.proposeDebtId,
                    "originalAuthorizedAmt": issueAuth.originalAuthorizedAmt,
                    "authorizationDate": issueAuth.authorizationDate,
                    "otherAuthorizationName": issueAuth.otherAuthorizationName,
                    "authorityReplenishAmt": issueAuth.authorityReplenishAmt,
                    "authorityReducedAmt": issueAuth.authorityReducedAmt,
                    "createDatetime": new Date(),
                    "createUser":  CommonService.getUserName(user),
                    "lastUpdateDatetime": new Date(),
                    "lastUpdateUser":  CommonService.getUserName(user)
                }
            }
        };
        
            BaseService.processRequest(obj)
                .then((result) => {
                    if (result.data.errors && result.data.errors.length > 0){
                            toast.error(result.data.errors[0].message)
                    }
                    else{
                        toast.success("Issuer Authorization updated successfully!");
                        onModalClose();
                    }

                });
        }
    }
    
    return (
        <Modal show={true} backdrop="static" onHide={onModalClose}>
            <Modal.Header closeButton><h3>Edit Issuer Authorization</h3></Modal.Header>
            <Modal.Body>
            <form id="edit-issue-authorization">
                <div className="contactForm">
                    <Row>
                            <Col md={6} className="control">
                                <FormInput
                                    label="CDIAC Number"
                                    type="text"
                                    value={cdiacNumber}
                                    disabled
                                    readOnly
                                />
                            </Col>
                            <Col md={6} className="control">
                                <FormInput
                                    label="Authorization Name"
                                    type="text"
                                    value={issueAuth.authorizationName}
                                    disabled
                                    readOnly
                                />
                            </Col>
                            <Col md={6} className="control">
                                <FormInput
                                    label="Authorization Id"
                                    type="text"
                                    value={issueAuth.authorizationId}
                                    disabled
                                    readOnly
                                />
                            </Col>
                    </Row>
                    <Row>
                            <Col md={6} className="control">
                                <FormInput
                                    label="Authorization Date"
                                    type="text"
                                    value={CommonService.dateFormatter(issueAuth.authorizationDate)}
                                    disabled
                                    readOnly
                                />
                            </Col>
                            <Col md={6} className="control">
                                <FormInput
                                    label="Authorization Original Amount"
                                    type="text"
                                    value={CommonService.currencyFormatter(issueAuth.originalAuthorizedAmt)}
                                    disabled
                                    readOnly
                                />
                            </Col>
                    </Row>
                    <Row>             
                        <Col md={6} className="control">
                                <span className="required">* </span>
                                <CurrencyInput
                                    placeholder="0.00"
                                    label="Authority Reduced Amount"
                                    name="authorityReducedAmt"
                                    type="text"
                                    onChange={(e) => handleIssueAuthChange(e)}
                                    value={issueAuth.authorityReducedAmt}
                                    validations={["required", "max:999999999999.99"]}
                                />
                                {formErrors['authorityReducedAmt'] && <span className="error">{formErrors['authorityReducedAmt']}</span>}

                        </Col>                 
                        <Col md={6} className="control">
                            <span className="required">* </span>
                                <CurrencyInput
                                    placeholder="0.00"
                                    label="Authority Replenish Amount"
                                    name="authorityReplenishAmt"
                                    type="text"
                                    onChange={(e) => handleIssueAuthChange(e)}
                                    value={issueAuth.authorityReplenishAmt}
                                    validations={["required", "max:999999999999.99"]}
                                />
                            {formErrors['authorityReplenishAmt'] && <span className="error">{formErrors['authorityReplenishAmt']}</span>}
                        </Col>
                    </Row>
                </div>
                <div className="btn-div">
                <div className="fright">
                    <button type="button" className="custom-button-secondary  btn-secondary" onClick={onModalClose}>Cancel</button>{" "}
                    <button className="custom-button" type="button" onClick={(e)=>handleSubmit(e)}>Update Issuer Authorization</button>
                    </div>
                </div>
            </form>                
            </Modal.Body>
        </Modal>
    )
}

export default EditIssueAuthorization
